<template>
  <v-app>
    <Navbar :key="$route.fullPath" />
    <TopBackground />
    <v-main style="background: #f6f9fc">
      <v-container fluid>
        <router-view />
      </v-container>
    </v-main>
    <CookieConsent />
    <v-footer :padless="true">
      <Footer />
    </v-footer>
  </v-app>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import TopBackground from "./components/TopBackground.vue";
import Footer from "./components/Footer.vue";
import CookieConsent from "./components/CookieConsent.vue";

export default {
  components: { Navbar, TopBackground, Footer, CookieConsent },
  name: "FaangIT",

  data: () => ({
    appTitle: "FaangIT.com",
    sidebar: false,
    menuItems: [
      { title: "Home", path: "/home", icon: "mdi-home" },
      { title: "Register", path: "/signup", icon: "mdi-account-plus" },
      { title: "Log in", path: "/signin", icon: "mdi-login" },
    ],
  }),
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Roboto");
</style>
